import * as React from "react"
import Navbar from "../../components/Navbar"
import Hero from "../../components/Hero"
import trainingHero from "../../images/trainingHero.png"
import trainingHeroSmall from "../../images/trainingHeroSmall.png"
import Cta from "../../components/Cta"
import cloud_technologies_tab_image from "../../images/cloud_technologies_tab_image.svg"
import containerization_tab_image from "../../images/containerization_tab_image.svg"
import devops_automation_tab_image from "../../images/devops_automation_tab_image.svg"
import security_tab_image from "../../images/security_tab_image.svg"

import Footer from "../../components/Footer"

import Tabs from "../../components/Tabs"
import WhyChooseCognetiks from "../../components/TrainingPage/WhyChooseCognetiks"
import Cursor from "../../components/Cursor"

const heroContent = {
  primaryTitle: "Training Services at Cognetiks: ",
  secondaryTitle: "Unlocking Your Potential",
  description: `At Cognetiks, we believe in empowering individuals and organizations through knowledge. Our training services are meticulously crafted to enhance your skills, keeping you at the forefront of technology and innovation.`,
}

const trainingCtaContent = {
  title: "Ready to Elevate Your Skills?",
  description:
    "Invest in your professional development with Cognetiks. Whether you're an individual looking to upskill or an organization seeking comprehensive training for your team, we've got you covered. Explore our training programs and take the first step towards unlocking your full potential.",
}

const containerisationTabsContent = {
  secondaryTitle:
    "Unlock your potentials by increasing your understanding of the cloud.  ",
  mainTitle: "Our Training Programs",
  tabs: [
    {
      name: "Cloud Technologies",
      image: cloud_technologies_tab_image,
    },
    {
      name: "DevOps and Automation",
      image: devops_automation_tab_image,
    },
    {
      name: "Containerization and Orchestration",
      image: containerization_tab_image,
    },
    {
      name: "Security and Compliance",
      image: security_tab_image,
    },
  ],
}

const Training = () => {
  return (
    <main>
      <Navbar />
      <Hero content={heroContent} image={[trainingHero, trainingHeroSmall]} />
      {/* <WhatIsSoftwareDevelopment /> */}
      {/* <SoftwareDevelopmentBenefits /> */}
      <WhyChooseCognetiks />

      <Tabs content={containerisationTabsContent} />

      <Cta
        color1="#3D4AC2"
        color2="#5EEDDC"
        textColor="#446AC7"
        image={trainingHeroSmall}
        content={trainingCtaContent}
      />
      <Footer />
      <Cursor />
    </main>
  )
}

export default Training

export const Head = () => (
  <>
    <title>Services | Training</title>
  </>
)
